import { useContext } from 'react';
import { FormFieldContext } from '../context/FormFieldContext.js';

var useFormFieldContext = function useFormFieldContext() {
  return useContext(FormFieldContext);
};

export { useFormFieldContext };
//# sourceMappingURL=useFormFieldContext.js.map
